export const environment = {
  production: true,
  type: 'live',
    accept: '10web',
  baseUrl: 'https://10web.io/',
  dashUrl: 'https://my.10web.io/',
  demoUrls: ['https://10web-site.ai', 'https://aisite.10web.io'],
    vibeCodingEndpoint: 'https://proxy.ai-website-builder.net/wvc/api',
    coreEndpoint: 'https://proxy.ai-website-builder.net/core/api/',
    authEndpoint: 'https://proxy.ai-website-builder.net/auth/',
    publicEndpoint: 'https://proxy.ai-website-builder.net/core/public/api/',
    managerEndpoint: 'https://proxy.ai-website-builder.net/manager/api/',
    backupEndpoint: 'https://proxy.ai-website-builder.net/backup/api/',
    optimizerEndpoint: 'https://proxy.ai-website-builder.net/imageoptimizer/',
    seoEndpoint: 'https://proxy.ai-website-builder.net/seo/api/',
    performanceEndpoint: 'https://proxy.ai-website-builder.net/performance/v1/',
    securityEndpoint: 'https://proxy.ai-website-builder.net/security/api/',
    notificationsEndpoint: 'https://proxy.ai-website-builder.net/notifications/api/',
    notificationsSocketEndpoint: 'wss://notifications',
    lxdEndpoint: 'https://proxy.ai-website-builder.net/lxd/api/',
    typeFormEndpoint: 'https://proxy.ai-website-builder.net/api.typeform.com',
    aiAssistantEndpoint: 'https://proxy.ai-website-builder.net/ai-assistant/',
    optimizerDemonstrationEndpoint: 'https://proxy.ai-website-builder.net/optimizerdemonstration/api',
    aiBuilderEndpoint: 'https://proxy.ai-website-builder.net/x/api/',
    woocomEndpoint: 'https://proxy.ai-website-builder.net/woocommerce/woocommerce/',
    tenWebWoocomEndpoint: 'https://proxy.ai-website-builder.net/woocommerce/tenwebwoocommerce/',
    tenWebStripeEndpoint: 'https://proxy.ai-website-builder.net/woocommerce/payments-stripe/',
    woocomPaymentsEndpoint: 'https://proxy.ai-website-builder.net/woocommerce/payments/',
    woocomAnalyticsEndpoint: 'https://proxy.ai-website-builder.net/woocommerce/woocommerce-analytics/',
    expertsUrl: 'https://proxy.ai-website-builder.net/experts/',
    miniProductsEndpoint: 'https://proxy.ai-website-builder.net/mini-products/api/',
    miniToolsEndpoint: 'https://proxy.ai-website-builder.net/brand-kit/',
  wvcAcceptToken: 'jhUy2ZMrzOrbLWD8gdgdKSox9hpxV51NkZDbhis6H3Oy',
  stripeKey: 'pk_live_51O9OFOD2fAmjePnCvS6Qe7mr7qkXq2f0AYzmUcVmE70R2SUEbOz7ta4C4Q5LVId5BP2QIj2YZD1sxxLPQpraIkY800rIRUJA2S',
  googleRecaptcha: '6LeKu8YqAAAAAOjyZPPHbrgbaKFYqTP0groE1hJk',
  paypalIsProduction: true,

  enableGoogleAnalytics: true,
  enableLuckyOrange: true,

  hostname: '10web.site',

  firebaseConfig: {
    apiKey: "AIzaSyAoNT1N-gPZTqfmso7kFaKc-feY6w_MMtg",
    authDomain: "notifications-production.firebaseapp.com",
    databaseURL: "https://notifications-production.firebaseio.com",
    projectId: "notifications-production",
    storageBucket: "notifications-production.appspot.com",
    messagingSenderId: "635152696852"
  },
  firebasePublicConfig: {
    apiKey: "AIzaSyB2Iqwy5KcXMgbTpy-5HfGHVMK-WggBdHA",
    authDomain: "tenweb-hosting-services.firebaseapp.com",
    databaseURL: "https://tenweb-hosting-services.firebaseio.com",
    projectId: "tenweb-hosting-services",
    storageBucket: "tenweb-hosting-services.firebasestorage.app",
    messagingSenderId: "179822974689"
  },
  googleInsightsKey: 'AIzaSyC5kvK80IwtG9PBFfuXRzLZmxIh7MAB_tA',
  defaultStarterPlanId: 318,
  apiResellerPlanId: 458,
  speedStartedPlanId: 321,
  basePlanId: 320,
  boosterBetaPlanId: 322,
  photoGalleryPluginIds: ['204', '101'],
  aiBuilderPluginIds: ['191', '207', '215'],
  aiAssistantPluginId: 205,
  demoAiPluginId: 207,
  demoDomainId: 308386,
  demoWorkspaceId: 200401,
  imageOptimizerPluginId: 69,
  aiCreateWebsitePluginId: 212,
  managerPluginId: 51,
  installBlankPluginId: 213,
  builder2PluginId: 215,
  builder2HostedPluginId: 217,
    vibeCodingPluginId: 221,
    availableSubscriptionId: 368,
    suiteDevRoleId: 5,
  smoochIntegrationId: "62e93d22b600c900ef13330f",
  hubspotAgencyFormId: "e7a36373-ddcd-4150-818b-5b9095162b7d",
  hubspotDedicatedFormId: "2bb94ede-d978-419e-8843-e07baf6e8600",
  hubspotAiBuilderFormId: "12974eb0-ad55-4d40-892f-690c06d80343",
  demoWebsiteUrl: 'https://generous-malamute-1.10web.site',
  aiStarterAnnual: 375,
};
